import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../../components/ui/dialog';
import { Button } from '../../components/ui/button';
import { Label } from '../../components/ui/label';
import { Checkbox } from '../../components/ui/checkbox';
import { Download, CheckSquare, Loader2, FileText } from 'lucide-react';
import { formatLastFirst } from '../../lib/nameFormat';

export const GenerateTemplateDialog = ({
  open,
  onOpenChange,
  selectedTemplate,
  employees,
  selectedEmployees,
  toggleEmployee,
  selectAllEmployees,
  onGenerate,
  generating,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle className="font-heading flex items-center gap-2">
          <Download className="h-5 w-5 text-primary" />
          Dokumente generieren
        </DialogTitle>
        {selectedTemplate && (
          <p className="text-muted-foreground">
            Vorlage: {selectedTemplate.name}
          </p>
        )}
      </DialogHeader>
      <div className="space-y-4 pt-4">
        <div className="flex items-center justify-between">
          <Label>Mitarbeiter auswählen</Label>
          <Button variant="ghost" size="sm" onClick={selectAllEmployees}>
            <CheckSquare className="h-4 w-4 mr-1" />
            {selectedEmployees.length === employees.length ? 'Keine' : 'Alle'}
          </Button>
        </div>

        <div className="border rounded-lg max-h-[300px] overflow-y-auto">
          {employees.map((emp) => (
            <div
              key={emp.id}
              role="button"
              tabIndex={0}
              className={`flex items-center gap-3 p-3 border-b last:border-b-0 cursor-pointer hover:bg-secondary/30 ${
                selectedEmployees.includes(emp.id) ? 'bg-primary/5' : ''
              }`}
              onClick={() => toggleEmployee(emp.id)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  toggleEmployee(emp.id);
                }
              }}
            >
              <Checkbox
                checked={selectedEmployees.includes(emp.id)}
                onCheckedChange={() => toggleEmployee(emp.id)}
              />
              <div className="flex-1">
                <p className="font-medium">{formatLastFirst(emp)}</p>
                <p className="text-xs text-muted-foreground">
                  {emp.employee_number} • {emp.position || 'Keine Position'}
                </p>
              </div>
            </div>
          ))}
        </div>

        <p className="text-sm text-muted-foreground">
          {selectedEmployees.length} von {employees.length} Mitarbeiter ausgewählt
        </p>

        <div className="flex justify-end gap-3 pt-4">
          <Button variant="outline" onClick={() => onOpenChange(false)} className="rounded-full">
            Abbrechen
          </Button>
          <Button
            onClick={() => onGenerate(false)}
            disabled={generating || selectedEmployees.length === 0}
            variant="outline"
            className="rounded-full"
            data-testid="generate-docx-btn"
          >
            {generating ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Generiere...
              </>
            ) : (
              <>
                <Download className="mr-2 h-4 w-4" />
                Word (.docx)
              </>
            )}
          </Button>
          {selectedTemplate?.file_type === 'docx' && (
            <Button
              onClick={() => onGenerate(true)}
              disabled={generating || selectedEmployees.length === 0}
              className="rounded-full"
              data-testid="generate-pdf-btn"
            >
              {generating ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Generiere...
                </>
              ) : (
                <>
                  <FileText className="mr-2 h-4 w-4" />
                  PDF
                </>
              )}
            </Button>
          )}
        </div>
      </div>
    </DialogContent>
  </Dialog>
);
